<template>
	<div class="mx-3">
        <!-- <h2 style="text-align: center;">伴生质子束用户系统</h2> -->
        <h4 style="text-align: left; color: RGB(33, 150, 243);">1. 软件说明</h4>
        <p style="text-indent: 2em">
            此系统为伴生质子束用户实验提供了提案申请、提案审批和实验总结功能。
        </p>
        <p style="text-indent: 2em">
            用户可使用自己在 CSNS 用户系统或 Back-n 用户系统中已有账号，登录此系统并提交提案申请。
        </p>
		<p style="text-indent: 2em">
            此系统除了支持在PC端访问，同时也支持手机端访问。
        </p>

        <h4 style="text-align: left; color: RGB(33, 150, 243);">2. 用户权限划分</h4>
        <p style="text-indent: 2em">
            用户权限分为四类：普通用户，预审核人员，审核人员，查阅人员，管理员。
        </p>

        <h4 style="text-align: left; color: RGB(33, 150, 243);">3. 功能介绍</h4>
        <ul>
            <li>提案提交：用户填写并提交提案申请。</li>
            <li>提案审核：预审核人和审核人对已提交的提案申请进行审核。</li>
            <li>提案查看：预审核人、审核人和查阅人可查看所有提案。</li>
            <li>实验总结：用户填写并提交提案总结。</li>
            <li>申请表：生成PDF申请表。</li>
            <li>实验记录：生成PDF实验记录。</li>
        </ul>

        <h4 style="text-align: left; color: RGB(33, 150, 243);">4. 工作流</h4>
        <ul>
            <li>步骤1：用户提交提案申请。</li>
            <li>步骤2：预审核人对提案进行预审核。</li>
            <li>步骤3：审核人对提案进行审核。</li>
            <li>步骤4：实验结束以后，用户提交实验总结。</li>
        </ul>

    </div>
</template>

<script>
export default {
	
}
</script>

<style scoped>

</style>
